import MoneyFormat from "@/src-refactor/modules/shared/helpers/moneyFormat.helper";
import {
  C_BUSINESS_TYPE,
  O_BUSINESS_TYPE
} from "@/src-refactor/modules/shared/model/const/property/business-type.const";

export const HCheckTypeBusinessType = (id: number) => {
  return {
    isSale: [
      C_BUSINESS_TYPE.SALE.id,
      C_BUSINESS_TYPE.SALE_FURNISHED.id,
      C_BUSINESS_TYPE.WHITE_LINE_SALES.id
    ].includes(id),
    isRent: [
      C_BUSINESS_TYPE.RENT_FURNISHED.id,
      C_BUSINESS_TYPE.SELL.id,
      C_BUSINESS_TYPE.WHITE_LINE_RENTAL.id
    ].includes(id),
    isRentAndSale: [
      C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL.id,
      C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS.id,
      C_BUSINESS_TYPE.SALE_AND_SELL.id
    ].includes(id)
  };
};

interface IHPreparePriceArg {
  businessTypeId: number;
  price: string;
  alternativePrice: string;
  currencyPrice: string;
  currencyAlternativePrice: string;
  isProject: boolean;
  minimumPrice: string;
  maximumPrice: string;
  mode?: "detail" | "list";
}

export const HPreparePrice = (arg: IHPreparePriceArg) => {
  if (arg.mode === "detail") {
    return preparePriceDetail(arg);
  } else {
    return preparePriceList(arg);
  }
};

const preparePriceDetail = (arg: IHPreparePriceArg) => {
  const { isRent, isRentAndSale, isSale } = HCheckTypeBusinessType(
    arg.businessTypeId
  );
  const business = O_BUSINESS_TYPE[arg.businessTypeId];

  if (arg.isProject) {
    return [
      {
        label: business.extra.saleLabel,
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.minimumPrice)} - ${
          arg.currencyPrice
        }$ ${MoneyFormat(arg.maximumPrice)}`
      }
    ];
  } else if (isRent || isSale) {
    return [
      {
        label: `${business.extra.rentLabel || business.extra.saleLabel} ${
          business.extra.detailLabel
        } `,
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.price)}`
      }
    ];
  } else if (isRentAndSale) {
    return [
      {
        label: `${"Venta " + business.extra.detailLabel}`,
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.price)}`
      },
      { 
        label: `${"Alquiler " + business.extra.detailLabel}`,
        value: `${arg.currencyAlternativePrice}$ ${MoneyFormat(
          arg.alternativePrice
        )}`
      }
    ];
  } else return [];
};

const preparePriceList = (arg: IHPreparePriceArg) => {
  const { isRent, isRentAndSale, isSale } = HCheckTypeBusinessType(
    arg.businessTypeId
  );
  const business = O_BUSINESS_TYPE[arg.businessTypeId];

  if (arg.isProject) {
    return [
      // {
      //   label: business.extra.saleLabel,
      //   value: `${arg.currencyPrice}$ ${arg.minimumPrice} - ${arg.currencyPrice} ${arg.maximumPrice}`
      // },
      {
        label: "Venta",
        value: ``
      },
      {
        label: "Desde",
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.minimumPrice)} `
      },
      {
        label: "Hasta",
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.maximumPrice)}`
      }
    ];
  } else if (isRent || isSale) {
    return [
      {
        label: business.extra.detailLabel,
        value: ""
      },
      {
        label: business.extra.rentLabel || business.extra.saleLabel,
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.price)}`
      }
    ];
  } else if (isRentAndSale) {
    return [
      {
        label: business.extra.detailLabel,
        value: ``
      },
      {
        label: "Venta",
        value: `${arg.currencyPrice}$ ${MoneyFormat(arg.price)}`
      },
      {
        label: "Alquiler",
        value: `${arg.currencyAlternativePrice}$ ${MoneyFormat(
          arg.alternativePrice
        )}`
      }
    ];
  } else return [];
};
